import Immutable from 'seamless-immutable';

/**
 * Receives an array of strings, and returns an obj with that strings as
 * properties with that string as value.
 * E.G:
 * stringArrayToObject(['A', 'B', 'C']) // { A: 'A', B: 'B', C: 'C' }
 */
export function stringArrayToObject(actionsArray, namespace = '') {
  if (actionsArray.some(actionName => !actionName || typeof actionName !== 'string')) {
    throw new Error('Action names must be strings and must not be empty');
  }
  return Immutable(actionsArray).asObject(actionName => [actionName, `${namespace}:${actionName}`]);
}

export function arrayOfIndices(length) {
  // .fill(<something not undefined>) is required for map, map ignores undefined values
  return Array(length).fill(null).map((_, index) => index);
}

export default {
  stringArrayToObject,
  arrayOfIndices,
};



// WEBPACK FOOTER //
// ./src/utils/array.js